<template>
  <div v-if="showToast" class="toast">
    <span>{{msg}}</span>
  </div>
</template>

<script>
  import bus from '../utils/eventBus';
  export default {
    name: "Toast",
    data(){
      return{
        msg: '',
        showToast: false
      }
    },
    created(){
      let _this = this;
      bus.$on('showToast', function(msg) {
        _this.msg = msg;
        _this.showToast = true;
        setTimeout(function () {
          _this.showToast = false;
        }, 2000)
      });
    }
  }
</script>

<style lang="scss" scoped>
  .toast{
    $commonRed: #e90029;
    $toastBg: #f6dedf;
    $color: #524f56;
    padding: 7px 30px;
    border: 1px solid $commonRed;
    background-color: $toastBg;
    position: fixed;
    left: 50%;
    top: 42%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    z-index: 999;
    span{
      font-size: 16px;
      color: $color;
    }
  }
</style>